/**
 *  资源属性模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const resource = {
  //得到所有菜单
  menus() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/menus`,{
      mask: false,
    });
  },
  //得到CIY角色
  role() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/role`, {
      mask: false
    });
  },
  //得到所有角色
  roleCiyAndVen() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/role_ciy_ven`, {
      mask: false
    });
  },
  //得到所有事业部
  grandDivs() {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/grand-divs`, {
      mask: false
    });
  },
  //得到所有部
  departments(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/departments`, {
      mask: false,
      params: params
    });
  },
  //得到所有DPT
  dpts(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/dpts`, {
      mask: false,
      params: params
    });
  },
  //得到所有售场分类
  lines(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/lines`, {
      mask: false,
      params: params
    });
  },
  //得到所有商品分类
  classes(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/classes`, {
      mask: false,
      params: params
    });
  },
  //得到所有店铺数据
  stores(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/stores`, {
      mask: false,
      params: params
    });
  },
  //根据资源等级 得到 指定参数得相信细细
  getInfoByLevel(code,_level) {
    ///resource/item/{code}/level
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/item/`+code+`/level`, {
      mask: false,
      params: {
        level:_level
      }
    });
  },
  //得到所有部（非资源）
  openDepartments(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/open-departments`, {
      mask: false,
      params: params
    });
  },
  //得到所有DPT（非资源）
  openDpts(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/open-dpts`, {
      mask: false,
      params: params
    });
  },
  //得到所有售场分类（非资源）
  openLines(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/open-lines`, {
      mask: false,
      params: params
    });
  },
  //得到所有商品分类（非资源）
  openClasses(params) {
    return axios.get(`${Vue.prototype.$base.API_PATH}/resource/open-classes`, {
      mask: false,
      params: params
    });
  },
}

export default resource;



// WEBPACK FOOTER //
// ./src/api/resource.js